import { useParams, Navigate } from "react-router-dom";
import SEO from "../components/SEO";
import { useTheme } from "../context/ThemeContext";

const TITLES = {
  privacy: "Privacy Policy",
  returns: "Return & Refund Policy",
  shipping: "Shipping Policy",
  terms: "Terms & Conditions",
};

export default function Policy() {
  const { type } = useParams();
  const { content } = useTheme();
  const title = TITLES[type];
  if (!title) return <Navigate to="/" />;
  const text = content[`policy_${type}`] || "";
  const blocks = text.split("\n\n").map((b) => b.trim()).filter(Boolean);

  return (
    <div className="max-w-3xl mx-auto px-4 py-16" data-testid={`policy-${type}`}>
      <SEO title={title} description={`${title} — Humaira Crafts`} />
      <h1 className="text-4xl md:text-5xl tracking-tighter font-semibold mb-12">{title}</h1>
      <div className="flex flex-col gap-6">
        {blocks.map((b, i) => b.startsWith("## ") ? (
          <h2 key={i} className="font-serif text-2xl font-semibold mt-4">{b.replace(/^## /, "")}</h2>
        ) : (
          <p key={i} className="text-sm text-muted-foreground leading-relaxed">{b}</p>
        ))}
      </div>
      <p className="text-xs text-muted-foreground mt-16 border-t border-black/10 pt-6">Last updated: July 2026 · Humaira Crafts, Delhi, India</p>
    </div>
  );
}
